import { render, staticRenderFns } from "./validation-task-status-label.vue?vue&type=template&id=e013e7de&scoped=true"
import script from "./validation-task-status-label.vue?vue&type=script&lang=js"
export * from "./validation-task-status-label.vue?vue&type=script&lang=js"
import style0 from "./validation-task-status-label.vue?vue&type=style&index=0&id=e013e7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e013e7de",
  null
  
)

export default component.exports